import { render } from "./chart-stat.vue?vue&type=template&id=71590f2a"
import script from "./chart-stat.vue?vue&type=script&lang=js"
export * from "./chart-stat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__